import { Flex, Text } from '@chakra-ui/react'
import { ManageMedia } from '../'

export default function ManageMediaPage() {
  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      mr={{ base: 0, sm: 5 }}
      mb={2}
      p={{ base: 4, sm: 0 }}
      overflowY={'auto'}
    >
      <Text textStyle="h2" p={2} pt={7}>
        Media Content
      </Text>
      <ManageMedia />
    </Flex>
  )
}
